import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { PopupService } from 'app/services/shared/popup.service';
import { CarrierService } from 'app/services/carrier.service';

@Component({
  selector: 'app-ca-landing-page-noaccount',
  templateUrl: './ca-landing-page-noaccount.component.html',
  styleUrls: ['./ca-landing-page-noaccount.component.css']
})
export class CaLandingPageNoaccountComponent implements OnInit {
  isPhonePortrait = false;
  isHandsetLandscape = false;
  hideSideMenu: false;

  constructor(private responsive: BreakpointObserver,private showModal: PopupService,private carrierService: CarrierService) { }

  ngOnInit(): void {
    this.responsive.observe([
      Breakpoints.HandsetLandscape,      
      Breakpoints.TabletLandscape,
      ])
      .subscribe(result => {

        this.hideSideMenu = false; 
        this.isPhonePortrait = false; 
        this.isHandsetLandscape = false;


        if (result.matches) {
          this.isPhonePortrait = true;
        }
        if (result.matches) {
          this.isHandsetLandscape = true;
        } });
  }

  setCarrierCodeFocus() {
    $('#myModal').on('shown.bs.modal', function () {
        $('#carrierCode').focus();
    })  

}
}
